<template>
  <div class="outter">
    <div class="title wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
      <h4>行业解决方案</h4>
      <p>沉淀金蝶27年、百万用户最全面的业务场景，结合金蝶集团技术创新能力，提供云原生、数据智能、零售、制造、服务等多个领域的解决方案</p>
    </div>
    <div class="menu wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s">
      <div slot="button-prev" class="button-prev"><h1>←</h1></div>
      <div class="menubar">
        <swiper :options="swiperOption" class="swiper">
          <swiper-slide><div :class="istrue===1? 'ontrue': null" class="innerswiper" @mouseenter="jump(0)">制造行业</div></swiper-slide>
          <swiper-slide><div :class="istrue===2? 'ontrue': null" class="innerswiper" @mouseenter="jump(1)">批发于零售</div></swiper-slide>
          <swiper-slide><div :class="istrue===3? 'ontrue': null" class="innerswiper" @mouseenter="jump(2)">交通运输行业</div></swiper-slide>
          <swiper-slide><div :class="istrue===4? 'ontrue': null" class="innerswiper" @mouseenter="jump(3)">医药健康行业</div></swiper-slide>
          <swiper-slide><div :class="istrue===5? 'ontrue': null" class="innerswiper" @mouseenter="jump(4)">数字政府</div></swiper-slide>
          <swiper-slide><div :class="istrue===6? 'ontrue': null" class="innerswiper" @mouseenter="jump(5)">建筑行业</div></swiper-slide>
          <swiper-slide><div :class="istrue===7? 'ontrue': null" class="innerswiper" @mouseenter="jump(6)">房地产行业</div></swiper-slide>
          <swiper-slide><div :class="istrue===8? 'ontrue': null" class="innerswiper" @mouseenter="jump(7)">物业管理</div></swiper-slide>
        </swiper>
      </div>
      <div slot="button-next" class="button-next"><h1>→</h1></div>
    </div>
    <div class="carousel wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s">
      <!-- <ul class="list">
      <li class="listItem" @mouseenter="jump(1)">123123</li>
      <li class="listItem" @mouseenter="jump(2)">43241</li>
    </ul> -->
      <b-carousel
        id="carousel-1"
        ref="myCarousel2"
        v-model="slide"
        :interval="0"
        fade
        img-width="100%"
        style="text-shadow: 1px 1px 2px #333"
      >
        <!-- Text slides with image -->
        <b-carousel-slide style="position:relative">
          <template #img>
            <img
              :src="require('../assets/home/s1.png')"
              class="d-block img-fluid w-1000"
              width="1024"
              height="480"
              alt="image slot"
            >
          </template>
          <div class="imgtext">
            <h2 class="animate__animated fadeInRight">金蝶小微企业成长指数</h2>
            <p class="animate__animated fadeInRight delays">
              经营破局 数据创赢
            </p>
            <p class="animate__animated fadeInRight delays">
              健康小微 成长最美
            </p>
            <div class="button-group animate__animated fadeInRight delays2">
              <router-link to="/products">查看详情</router-link>
              <!-- <a>立刻咨询</a> -->
            </div>
          </div>
        </b-carousel-slide>

        <b-carousel-slide style="position:relative">
          <template #img>
            <img
              :src="require('../assets/home/s2.png')"
              class="d-block img-fluid w-1000"
              width="1024"
              height="480"
              alt="image slot"
            >
          </template>
          <div class="imgtext">
            <h2 class="animate__animated fadeInRight">批发与零售</h2>
            <p class="animate__animated fadeInRight delays">
              帮助且融合全渠道，打造新商业，塑造新管理。建设新平台。
            </p>
            <p class="animate__animated fadeInRight delays">
              全面，深度链接消费者
            </p>
            <div class="button-group animate__animated fadeInRight delays2">
              <router-link to="/products">查看详情</router-link>
              <!-- <a>立刻咨询</a> -->
            </div>
          </div>
        </b-carousel-slide>

        <b-carousel-slide style="position:relative">
          <template #img>
            <img
              :src="require('../assets/home/s3.png')"
              class="d-block img-fluid w-1000"
              width="1024"
              height="480"
              alt="image slot"
            >
          </template>
          <div class="imgtext">
            <h2 class="animate__animated fadeInRight">交通运输行业</h2>
            <p class="animate__animated fadeInRight delays">
              助力交通运输领域见客户转换管理模式，赋能企业数字化转型，
            </p>
            <p class="animate__animated fadeInRight delays">
              提高行业价值链的运营效率
            </p>
            <div class="button-group animate__animated fadeInRight delays2">
              <router-link to="/products">查看详情</router-link>
              <!-- <a>立刻咨询</a> -->
            </div>
          </div>
        </b-carousel-slide>

        <b-carousel-slide style="position:relative">
          <template #img>
            <img
              :src="require('../assets/home/s4.jpg')"
              class="d-block img-fluid w-1000"
              width="1024"
              height="480"
              alt="image slot"
            >
          </template>
          <div class="imgtext">
            <h2 class="animate__animated fadeInRight">医药健康行业</h2>
            <p class="animate__animated fadeInRight delays">
              从关注国人健康角度触发，为医药企业提供数字转型整体解决方案
            </p>
            <p class="animate__animated fadeInRight delays">
              助力医药企业加入大健康产业时代
            </p>
            <div class="button-group animate__animated fadeInRight delays2">
              <router-link to="/products">查看详情</router-link>
              <!-- <a>立刻咨询</a> -->
            </div>
          </div>
        </b-carousel-slide>

        <b-carousel-slide style="position:relative">
          <template #img>
            <img
              :src="require('../assets/home/s5.png')"
              class="d-block img-fluid w-1000"
              width="1024"
              height="480"
              alt="image slot"
            >
          </template>
          <div class="imgtext">
            <h2 class="animate__animated fadeInRight">数字政府</h2>
            <p class="animate__animated fadeInRight delays">
              以智能、安全。融合为设计理念，以预算、收支、核算为主线，
            </p>
            <p class="animate__animated fadeInRight delays">
              以财务一体化为目标
            </p>
            <div class="button-group animate__animated fadeInRight delays2">
              <router-link to="/products">查看详情</router-link>
              <!-- <a>立刻咨询</a> -->
            </div>
          </div>
        </b-carousel-slide>

        <b-carousel-slide style="position:relative">
          <template #img>
            <img
              :src="require('../assets/home/s6.png')"
              class="d-block img-fluid w-1000"
              width="1024"
              height="480"
              alt="image slot"
            >
          </template>
          <div class="imgtext">
            <h2 class="animate__animated fadeInRight">建筑行业</h2>
            <p class="animate__animated fadeInRight delays">
              为大中型建筑企业量身定制的企业一级化解决方案，帮助企业打造产业链一体化融合、生态体系建设与共享
            </p>
            <p class="animate__animated fadeInRight delays">
              <!-- 健康小微 成长最美 -->
            </p>
            <div class="button-group animate__animated fadeInRight delays2">
              <router-link to="/products">查看详情</router-link>
              <!-- <a>立刻咨询</a> -->
            </div>
          </div>
        </b-carousel-slide>

        <b-carousel-slide style="position:relative">
          <template #img>
            <img
              :src="require('../assets/home/s7.png')"
              class="d-block img-fluid w-1000"
              width="1024"
              height="480"
              alt="image slot"
            >
          </template>
          <div class="imgtext">
            <h2 class="animate__animated fadeInRight">房地产行业</h2>
            <p class="animate__animated fadeInRight delays">
              深耕行业20载，与中国企业共同成长，产品持续创新，引领房地产企业数字化转型
            </p>
            <p class="animate__animated fadeInRight delays">
              <!-- 健康小微 成长最美 -->
            </p>
            <div class="button-group animate__animated fadeInRight delays2">
              <router-link to="/products">查看详情</router-link>
              <!-- <a>立刻咨询</a> -->
            </div>
          </div>
        </b-carousel-slide>

        <b-carousel-slide style="position:relative">
          <template #img>
            <img
              :src="require('../assets/home/s8.png')"
              class="d-block img-fluid w-1000"
              width="1024"
              height="480"
              alt="image slot"
            >
          </template>
          <div class="imgtext">
            <h2 class="animate__animated fadeInRight">物业管理</h2>
            <p class="animate__animated fadeInRight delays">
              围绕IoT服务、业务服务、增值服务三个领域，赋能物业企业构建数字化能力，实现数据融合、平台集成
            </p>
            <p class="animate__animated fadeInRight delays">
              <!-- 健康小微 成长最美 -->
            </p>
            <div class="button-group animate__animated fadeInRight delays2">
              <router-link to="/products">查看详情</router-link>
              <!-- <a>立刻咨询</a> -->
            </div>
          </div>
        </b-carousel-slide>

        <!-- Slides with custom text -->
      </b-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Carousel2',
  props: {
    imgarray: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      showIndicator: true,
      istrue: 1,
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 30,
        slidesPerGroup: 1,
        loopFillGroupWithBlank: true,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev'
        }
      }
    }
  },
  watch: {
    imgarray: {
      handler(val, oldVal) {
        // console.log(val)
        // console.log('收到收到收到')
      },
      immediate: true
    }
  },
  mounted() {
    if (process.browser) {
      new this.$wow.WOW({
        live: false,
        offset: 0
      }).init()
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    prev() {
      this.$refs.myCarousel2.prev()
    },
    next() {
      this.$refs.myCarousel2.next()
    },
    jump(index) {
      this.$refs.myCarousel2.setSlide(index)
      this.istrue = index + 1
    }
  }
}
</script>
<style scoped>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 120px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadeInUp {
  animation-name: fadeInUp;
}

#img {
  display: flex;
}

.delays {
  animation-delay: 0.3s;
  animation-duration: 1s;
}

.delays2 {
  animation-delay: 0.7s;
  animation-duration: 1s;
}

.delays3 {
  animation-delay: 1.2s;
  animation-duration: 1s;
}

.imgtext h2 {
  font-size: 42px;
  font-weight: 700;
  margin-bottom: 14px;
}

.imgtext p {
  font-size: 16px;
  line-height: 30px;
}

.imgtext {
  text-align: left;
  margin-top: -250px;
  position: absolute;
  margin-left: -20px;
}

.button-group a {
  display: inline-block;
  width: 140px;
  height: 48px;
  line-height: 48px;
  border-radius: 5px;
  overflow: hidden;
  font-size: 16px;
  text-align: center;
  margin-right: 10px;
  color: #fff
  /* position: relative; */
}

.button-group a:first-child {
  background: linear-gradient(135deg, #0068dd, #00aeee);
}

.button-group a:last-child {
  border: 1px solid #fff;
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translate3d(120px, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadeInRight {
  animation-name: fadeInRight;
}

.list {
  display: inline-block;
  list-style: none;
  margin: 20px;
  padding-left: 0;
  /* 去掉 inline-block 产生的块间隙 */
  font-size: 0;
}

.listItem {
  display: inline-block;
  padding: 20px 30px;
  font-size: 15px;
  font-weight: 700;
  color: #969696;
  position: relative;
  /* border-bottom:dotted 10px #000; */
}

.listItem a {
  cursor: pointer;
  outline: 0;
  text-decoration: none;
}

.listItem a:hover {
  color: #646464;
}

.listItem:hover:after {
  opacity: 1;
  transform: translate(-50%) scaleX(1);
}

.listItem:after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -5px;
  width: 80%;
  opacity: 0;
  border-bottom: 2px solid #646464;
  transform: translate(-50%) scaleX(0);
  transition: 0.5s ease-in-out;
}

.w-1000 {
  width: 100%;
  min-height: 400px !important;
  object-fit: cover !important;
}

.title {
  text-align: left;
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}

.title p {
  font-size: 16px;
  color: #a3a3a3;
  line-height: 24px;
  margin-top: 14px;
}

.title h4 {
  font-size: 32px;
  color:white;
}

.outter {
  background-color: #020a55;
  padding-top: 100px;
}
.swiper-slide {
  height:40px;
}

.menu {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}

.menubar {
  width: 1000px;
  margin: auto;
}

.button-prev {
  width: 28px;
  height: 28px;
  overflow: hidden;
  border-radius: 50%;
  border: 4px solid #aab0c3;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.4s ease;
  margin: auto;
  margin-left: 0;
}
.button-next {
  width: 28px;
  height: 28px;
  overflow: hidden;
  border-radius: 50%;
  border: 4px solid #aab0c3;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.4s ease;
  margin: auto;
}

.button-next:hover {
  border:4px solid transparent;
}

.button-prev:hover {
  border:4px solid transparent;
}

.button-prev h1 {
  font-size: 20px;
  line-height: 17px;
  color: whitesmoke;
}

.button-next h1 {
  font-size: 20px;
  line-height: 17px;
  color: whitesmoke;
}

.innerswiper {
  cursor: pointer;
  color:white;
}

/* .innerswiper:hover {
    color: #646464;
} */

.innerswiper:hover:after {
    border-radius: 0;
    border-bottom: solid 1px whitesmoke;
    width:100%;
}

.innerswiper:after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0px;
    width: 7px;
    border-bottom: 7px solid whitesmoke;
    border-radius: 50%;
    transform: translate(-50%) scaleX(1);
    transition: .4s ease-in-out;
}

.ontrue:after {
  width: 100%;
  border-bottom: solid 1px whitesmoke;
  border-radius: 0;
}
</style>
<style>
.carousel-indicators {
  bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/planswiper.vue